<flx-resources-grid
  [tableDef]="documentsTableColumns"
  [inputGridOptions]="gridOptions()"
  (gridReady)="onGridReady($event)"
  emptyMsg="No documents"
  emptyMsgDescription="Every document this instance generated or received appears here, wherever it came from."
/>
